import { Component, Input} from '@angular/core';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.css'],
    standalone: false
})
export class EmptyStateComponent {
  @Input() title: string = 'No data available';
  @Input() message: string = 'There are no items to display at the moment.';
  @Input() iconPath: string = '/assets/emptyIcon.png';
}